import { Button } from './Button'

/**
 * Previous/next footer for a list the backend pages. Renders nothing when
 * everything already fits on one page, so callers can drop it in unconditionally.
 */
export function Pagination({
  total,
  offset,
  pageSize,
  onChange,
}: {
  total: number
  offset: number
  pageSize: number
  onChange: (offset: number) => void
}) {
  if (total <= pageSize) return null
  const to = Math.min(offset + pageSize, total)
  return (
    <div className="flex items-center justify-between gap-2">
      <p className="tabular text-xs text-ink-faint">
        Showing {offset + 1}–{to} of {total}
      </p>
      <div className="flex gap-1.5">
        <Button
          size="sm"
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - pageSize))}
        >
          Previous
        </Button>
        <Button size="sm" disabled={to >= total} onClick={() => onChange(offset + pageSize)}>
          Next
        </Button>
      </div>
    </div>
  )
}